<script lang="ts">
  import { Form } from "$lib/ui/form";
  import { makeApiRequest } from "$lib/utils/api";
  import { teamsListStore } from "$lib/stores/teams";
  import { userStore } from "$lib/stores/user";
  import { Input } from "$ui/input";
  import * as Select from "$ui/select";
  import * as yup from "yup";

  import { applyTheme, saveToast } from "$lib/utils/helpers";
  import SectionTitle from "$lib/components/shared/SectionTitle.svelte";

  let selectedMode = "light";

  const MODES = [
    { value: "system", label: "System (Default)" },
    { value: "light", label: "Light" },
    { value: "dark", label: "Dark" },
  ];

  let form: any;
  let validateField: any;
  let updateValidateField: any;

  $: teams = $teamsListStore;

  let initialValues = {
    name: $userStore?.name || "",
    primaryEmail: $userStore?.email || "",
    defaultTeam: $userStore?.defaultTeam || (teams && teams.length > 0 ? teams[0].id : ""),
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Display name is required"),
    defaultTeam: yup.string().required("Default team to redirect to if no team in the url"),
  });

  const onSubmit = async (values: any) => {
    await makeApiRequest(`/me/`, {
      name: values.name,
      primary_email: values.primaryEmail,
      default_team: values.defaultTeam,
    });
    saveToast("Settings Saved!", "Your preferences have been saved successfully.");
  };

  const changeMode = (mode: string) => {
    if (mode === "system") {
      localStorage.removeItem("mode");
    } else {
      localStorage.setItem("mode", mode);
    }
    applyTheme(mode);
  };
</script>

<div class="grow px-6 lg:px-10 py-5 sm:py-8 lg:py-10 text-offblack">
  <SectionTitle>Profile</SectionTitle>
  <div class="flex flex-col lg:flex-row gap-8 lg:gap-20">
    <div class="lg:max-w-xs xl:max-w-sm flex flex-col gap-2">
      <div class="font-semibold text-lg">Profile Settings</div>
      <p>Set your preferences here, what we should call you and your email address.</p>
    </div>
    <div class="flex-1 max-w-lg" id="settings-form">
      <Form bind:form {initialValues} {validationSchema} {onSubmit} bind:validateField bind:updateValidateField>
        {#if $form}
          <Input
            label="Display Name"
            name="name"
            bind:value={$form.name}
            on:input={() => {
              validateField("name");
              validateField("defaultTeam");
            }}
          />

          <Input label="Email" name="primaryEmail" bind:value={$form.primaryEmail} readonly />

          <!-- <Select.Root
            name="defaultTeam"
            selected={{
              value: teams.find((team) => team.id === $form?.defaultTeam)?.id ?? "",
              label: teams.find((team) => team.id === $form?.defaultTeam)?.alias ?? "",
            }}
            onSelectedChange={(v) => {
              validateField("defaultTeam");
              validateField("name");
              v && ($form.defaultTeam = v.value);
            }}
          >
            <Select.Trigger name="alias" label="Default Team">
              <Select.Value placeholder="Select a Team" />
            </Select.Trigger>
            <Select.Content class="max-h-[400px] overflow-auto">
              <Select.Group>
                {#each teams as team}
                  <Select.Item value={team.id} label={team.alias}>
                    <div class="flex-1 flex flex-col font-medium">
                      {team.alias}
                      <span class="text-xs p font-normal">
                        {team.id}
                      </span>
                    </div>
                  </Select.Item>
                {/each}
              </Select.Group>
            </Select.Content>
          </Select.Root> -->
        {/if}
      </Form>
    </div>
  </div>

  <div class="hidden border-t border-general mt-6 lg:mt-12 pt-6 lg:pt-12 flex flex-col lg:flex-row gap-8 lg:gap-20">
    <div class="lg:max-w-xs xl:max-w-sm flex flex-col gap-2">
      <div class="font-semibold text-lg">Appearance</div>
      <p>Set the Appearance of the App: Tailor Your Visual Experience to Suit Your Style Preferences</p>
    </div>

    <div class="flex-1 max-w-lg">
      <Select.Root
        selected={MODES.find((mode) => mode.value === selectedMode)}
        onSelectedChange={(mode) => {
          if (mode) {
            changeMode(mode.value);
          }
        }}
      >
        <Select.Trigger name="alias" label="Dark/Light Mode">
          <Select.Value placeholder="Select a Mode" />
        </Select.Trigger>
        <Select.Content>
          <Select.Group>
            {#each MODES as mode}
              <Select.Item value={mode.value} label={mode.label}>
                {mode.label}
              </Select.Item>
            {/each}
          </Select.Group>
        </Select.Content>
      </Select.Root>
    </div>
  </div>
</div>
